<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData" ref="form" label-width="160px" v-loading="loading">
        <el-row>
          <el-col :span="12">
            <el-form-item prop="specName" label="品种规格">
              {{ formData.specName || "" }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item prop="priceDiff" label="价格差(元)">
              {{ formData.priceDiff || "" }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item prop="isBulkOil" label="是否散油">
              {{
                formData.isBulkOil == "0"
                  ? "否"
                  : formData.isBulkOil == "1"
                    ? "是"
                    : ""
              }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item prop="unit" label="单位">
              {{ formData.unit || "" }}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :span="24">
          <el-col :span="24">
            <el-form-item label="图片" prop="specImage">
              <el-image style="width: 60px; height: 60px" :src="formData.specImage || YouImg"
                :preview-src-list="[formData.specImage || YouImg]" fit="cover" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :span="24">
            <el-form-item label="价格清单" prop="priceList">
              <el-table size="mini" stripe border :data="formData.priceList">
                <el-table-column min-width="120" label="单价(元)" prop="priceList.specPrice">
                  <template v-slot="{ $index }">
                    <el-form-item :prop="'priceList.' + $index + '.specPrice'" label="" label-width="0" :rules="[
                      {
                        required: true,
                        message: '请输入单价(元)',
                        trigger: ['blur', 'change']
                      }
                    ]">
                      <el-input v-model="formData.priceList[$index].specPrice" placeholder="请输入当前单价(元)"></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column min-width="120" label="数量" prop="priceList.numUp">
                  <template v-slot="{ $index }">
                    <el-form-item :prop="'priceList.' + $index + '.numUp'" label="" label-width="0" :rules="[
                      {
                        required: true,
                        message: '请输入数量',
                        trigger: ['blur', 'change']
                      }
                    ]">
                      <el-input-number :min="0" v-model="formData.priceList[$index].numUp"
                        placeholder="请输入数量"></el-input-number>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column width="150" label="操作" fixed="right">
                  <template v-slot="{ $index }">
                    <el-button type="text" class="del-btn" @click="delInput($index)"
                      v-if="formData.priceList.length > 1">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-button class="mt15" type="primary" @click="onAdd">新增</el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>

              <el-button type="primary" @click="submit">提交</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>
import YouImg from '@/assets/you.png'
import { deepClone } from '@/utils/utils'
export default {
  name: 'PriceControlEdit',

  data() {
    return {
      YouImg,
      formData: {
        typeId: '',
        specName: '',
        priceDiff: '',
        currentPrice: '',
        isPublished: '',
        isBulkOil: '',
        unit: '',
        productCode: '',
        specImage: '',
        priceList: []
      },

      loading: false
    }
  },
  created() {
    if (this.specId) {
      this.loadData()
    }
  },
  computed: {
    specId() {
      return this.$route.query.specId
    }
  },
  methods: {
    onAdd() {
      this.formData.priceList.push({
        specPrice: '',
        numUp: ''
        // oldPrice: '',
        // oldNum: ''
      })
    },

    delInput(index) {
      this.formData.priceList.splice(index, 1)
    },
    loadData() {
      this.loading = true
      this.$axios
        .get(this.$apis.priceControl.selectYxSpecPriceById, {
          params: { specId: this.specId }
        })
        .then(res => {
          res.priceList = res.priceList || []
          // res.priceList.forEach(item => {
          //   item.oldNum = item.numUp
          //   item.oldPrice = item.specPrice
          // })
          this.formData = res
        })
        .finally(() => {
          this.loading = false
        })
    },

    submit() {
      this.$refs.form
        .validate()
        .then(() => {
          this.loading = true

          const params = deepClone(this.formData)
          params.priceList = []

          this.formData.priceList.forEach(item => {
            params.priceList.push({
              specPrice: item.specPrice,
              numUp: item.numUp
            })
          })

          const info = this.formData.priceList.find(item => item.numUp === '0' || item.numUp === 0)
          if (!info) {
            this.$message.warning('价格清单缺少数量为0的区间!')
            return
          }
          const url = this.$apis.priceControl.insertAllYxSpecPrice

          this.$axios.post(url, params).then(() => {
            this.$router.back()
          })
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
.shoufa-form {
  width: 800px;
}

::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-cascader,
  .el-date-editor {
    width: 100%;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}
</style>
